import dayjs from 'dayjs';
import * as miniQrCode from '../services/miniQrCode';

//生成唯一id
function guid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
    36,
  );
}
export default {
  namespace: 'miniQrCode',

  state: {
    searchFormData: null,
    tableList: null,
    total: 0,
    hasNext: false,
    groupList: null,
    qrParamsFormData: [{ name: '', value: '', id: guid() }],
    refreshQrParamsFormData: '',
    defaultStores: null,
  },

  effects: {
    //查询表格数据
    *getQueryQrCodeGroupPage({ payload: { values }, callback }, { put, call }) {
      const response = yield call(miniQrCode.getQueryQrCodeGroupPage, values);
      yield put({
        type: 'save',
        payload: {
          hasNext: response?.data.hasNext,
          total: response?.data.total,
          tableList: response?.data?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //公众号下没有分组的时候，直接重置数据不做查询
    *initQrCodeTableList({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          total: 0,
          tableList: [],
        },
      });
    },
    //删除小程序码
    *deleteQrCodeGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(miniQrCode.deleteQrCodeGroup, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //删除分组
    *deleteGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(miniQrCode.deleteGroup, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //停用小程序码
    *stopQrCode({ payload: { values }, callback }, { call }) {
      const response = yield call(miniQrCode.stopQrCode, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },

    //获取小程序码的buffer
    *getQrCodeBuffer({ payload: { values }, callback }, { call }) {
      const response = yield call(miniQrCode.getQrCodeBuffer, values);
      callback && callback(response);
    },

    //点击添加一条小程序码参数
    *operationParamData(
      {
        payload: {
          values: { index, status },
        },
      },
      { select, put },
    ) {
      const { qrParamsFormData } = yield select((state) => state.miniQrCode);
      const qrParamsFormDataClone = [...qrParamsFormData];
      status === '1'
        ? qrParamsFormDataClone.splice(index + 1, 0, {
            name: '',
            value: '',
            id: guid(),
          })
        : qrParamsFormDataClone.splice(index, 1);
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
          refreshQrParamsFormData: dayjs().valueOf(),
        },
      });
    },
    *setParamData({ payload: { values } }, { put, select }) {
      const { index, value, key } = values;
      const { qrParamsFormData } = yield select((state) => state.miniQrCode);
      const qrParamsFormDataClone = qrParamsFormData.map((item, i) => {
        if (index === i) {
          return key === 'name' ? { ...item, name: value } : { ...item, value };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
          refreshPagePath: dayjs().valueOf(),
        },
      });
    },
    //新增小程序码
    *addQrCode(
      {
        payload: {
          values: { data },
        },
        callback,
      },
      { call },
    ) {
      const {
        appId,
        name,
        params,
        storeInfoList,
        storeKey,
        createType,
        importUrl,
        importFileName,
        id,
        pagePath,
        showLogo,
        channelList,
      } = data;
      const storeInfoListResult =
        storeInfoList?.length > 0
          ? storeInfoList.map((item) => ({
              ...item,
              storeName: item.name || item.storeName,
            }))
          : [];
      const postParams = {
        name,
        appId,
        params: params?.length > 0 && createType === '1' ? params : [],
        id,
        storeInfoList: createType === '1' ? storeInfoListResult : [],
        createType,
        storeKey: createType === '1' ? storeKey : null,
        importUrl: createType === '2' ? importUrl : null,
        importFileName: createType === '2' ? importFileName : null,
        pagePath,
        showLogo,
        channelList: channelList || [],
      };
      const response = yield call(miniQrCode.saveQrCodeGroup, postParams);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //查询小程序码
    *getQueryQrCode({ payload: { values }, callback }, { call, put }) {
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: [{ name: '', value: '', id: guid() }],
        },
      });
      const { urlType, ...p } = values;
      console.log({ urlType });
      const url = urlType
        ? miniQrCode.qrcodeGroupInfo
        : miniQrCode.getQueryQrCode;
      const response = yield call(url, p);
      if (!response?.data) {
        return false;
      }
      const result = (obj) =>
        obj.map(({ name, value }) => ({ name, value, id: guid() }));
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData:
            response?.data?.params && response?.data?.params.length > 0
              ? result(response?.data?.params)
              : [{ name: '', value: '', id: guid() }],
          defaultFormData: response.data,
          defaultStores: response?.data?.storeInfoList || [],
          refreshQrParamsFormData: dayjs().valueOf(),
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //清除参数的事件
    *clearOperationParamData({ payload: { values } }, { select, put }) {
      const { qrParamsFormData } = yield select((state) => state.miniQrCode);
      const { key, index } = values;

      const newQrParamsFormData = qrParamsFormData.map((item, ind) => {
        if (index === ind) {
          return { ...item, [key]: '', id: guid() };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: newQrParamsFormData,
        },
      });
    },
    //清除参数的事件
    *downQrcodeZip({ payload: { values }, callback }, { call }) {
      const response = yield call(miniQrCode.downQrcodeZip, values);
      callback && callback(response);
    },
    //批量新建小程序码
    *batchAddQrCode({ payload: { values }, callback }, { call }) {
      const response = yield call(miniQrCode.batchAddQrCode, values);
      callback && callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/miniapps/qr_code/qr_code_edit' ||
          props.pathname === '/miniapps/qr_code/qr_code_add' ||
          props.pathname === '/miniapps/qr_code/qr_code_detail' ||
          props.pathname === '/marketing/member_benefit_voucher/qr_code' ||
          props.pathname === '/marketing/luck_draw_view/qr_code'
        ) {
          dispatch({
            type: 'save',
            payload: {
              groupList: null,
              qrParamsFormData: [{ name: '', value: '', id: guid() }],
              defaultFormData: null,
              autoReplyList: null,
              refreshQrParamsFormData: '',
              defaultStores: null,
            },
          });
        }
      });
    },
  },
};
